module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-14 h-14"
  }, [_c('img', {
    staticClass: "w-full h-auto",
    attrs: {
      "src": _vm.value
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b6e14b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreviewImage.vue
// module id = 523
// module chunks = 1